import Helpers from '../../../../common/helpers/Helpers';
import Constants from '../../../../common/constants/Constants';

export const getInstrumentData = (
  serialNumber,
  selectedTableValue,
  dateFromISOString,
  dateToISOString
) => {
  let query = {
    SelectedInstrument: serialNumber,
    ReportName: selectedTableValue,
    StartDate: dateFromISOString,
    EndDate: dateToISOString
  };

  return Helpers.get(`${Constants.OLDREPORTS_URL}`, {}, query);
};
